import Swiper from 'swiper'
import SwiperCore, {Autoplay} from 'swiper/core'

SwiperCore.use([Autoplay])

export default class Promobar {
  constructor(component) {
    this.dom = {
      $component: component,
      $promos: component.querySelectorAll('.js-promo')
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    if (dom.$promos.length > 1) {
      this.initSlider()
    }
  }

  initSlider() {
    const {dom} = this
    const duration = parseInt(dom.$component.dataset.duration) * 1000
    const swiper = new Swiper('.js-promoSwiper', {
      loop: true,
      speed: 1,
      allowTouchMove: false,
      autoplay: {
        delay: duration,
        disableOnInteraction: false
      }
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.Promobar = this
  }
}
